import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useBrand } from "@/contexts/BrandContext";
import WhiteLabelLanding from "@/pages/WhiteLabelLanding";

/**
 * Marketing routes only exist on the main Snapshot Live site.
 * On a partner (white-label) host, "/" renders the partner landing page and
 * every other marketing page redirects back to "/".
 */
export function BrandGate({ children, isHome = false }: { children: ReactElement; isHome?: boolean }) {
  const { isWhiteLabel } = useBrand();
  if (!isWhiteLabel) return children;
  return isHome ? <WhiteLabelLanding /> : <Navigate to="/" replace />;
}

export default BrandGate;
